import React, { useState } from 'react';
import { ExtendedSelectorsBody } from '@components-shared/forms/ExtendedSelectors/ExtendedSelectorsBody';
import { IGroupOption, IGroupSelectorProps } from '@components-shared/forms/ExtendedSelectors/types';

export const LinkedSelectors = (props: IGroupSelectorProps) => {
  const { onChange, name, groupItemList, selectedGroupItemList, value } = props;
  const [options, setOptions] = useState<IGroupOption[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<string>('');
  const [selectedGroupOptionDisabled, setSelectedGroupOptionDisabled] = useState<boolean>(false);

  const onChangeGroup = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;

    const selectedGroupItemOptions = getFilteredItemOptions(selectedGroupItemList, value);
    const preferredOption = selectedGroupItemOptions.find((itemOption) => itemOption.preferred);

    setOptions(selectedGroupItemOptions);

    if (preferredOption) {
      preferredOptionHandler(preferredOption);
    } else {
      onChange(name, '');
      setSelectedGroup(value);
      setSelectedGroupOptionDisabled(false);
    }
  };

  const preferredOptionHandler = (preferredOption: IGroupOption) => {
    setSelectedGroup(String(preferredOption.filterBy));
    setSelectedGroupOptionDisabled(true);

    onChange(name, String(preferredOption.value));
  };

  const getFilteredItemOptions = (groupItemOptions: IGroupOption[], value: string) => {
    return groupItemOptions.filter((item) => item.filterBy === Number(value));
  };

  const onSelectedGroupOptionsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;

    onChange(name, value);
  };

  return (
    <ExtendedSelectorsBody
      {...props}
      value={value}
      onGroupChange={onChangeGroup}
      groupItemList={groupItemList}
      selectedGroupItemList={options}
      onSelectedGroupOptionsChange={onSelectedGroupOptionsChange}
      groupSelectedValue={selectedGroup}
      selectedGroupOptionsAttributes={{
        disabled: selectedGroupOptionDisabled,
      }}
    />
  );
};
